import { generateClient } from '@aws-amplify/api';
import {
  listAppointmentSlots,
  getAppointmentSlot
} from '../graphql/queries';
import {
  createAppointmentSlot,
  updateAppointmentSlot,
  deleteAppointmentSlot
} from '../graphql/mutations';

const client = generateClient();

// Get all slots (optionally filtered)
export const fetchSlots = async (filter = {}, limit = 20, nextToken = null) => {
  const now = new Date();
  const today = now.toISOString().split('T')[0];
  const currentTime = now.toTimeString().split(' ')[0];

  // Build a filter for future slots (date > today OR (date == today AND startTime > now))
  const futureFilter = {
    or: [
      { date: { gt: today } },
      {
        and: [
          { date: { eq: today } },
          { startTime: { gt: currentTime } }
        ]
      }
    ]
  };

  const result = await client.graphql({
    query: listAppointmentSlots,
    variables: {
      filter: { ...filter, ...futureFilter, isBooked: { eq: false } },
      limit,
      nextToken,
      sort: {
        direction: 'ASC',
        field: 'date'
      }
    }
  });
  return {
    items: result.data.listAppointmentSlots.items,
    nextToken: result.data.listAppointmentSlots.nextToken
  };
};

// Get a single slot by ID
export const getSlot = async (id) => {
  const result = await client.graphql({
    query: getAppointmentSlot,
    variables: { id }
  });
  return result.data.getAppointmentSlot;
};

// Create a new slot
export const createSlot = async (input) => {
  const result = await client.graphql({
    query: createAppointmentSlot,
    variables: { input }
  });
  return result.data.createAppointmentSlot;
};

// Update an existing slot
export const updateSlot = async (input) => {
  const result = await client.graphql({
    query: updateAppointmentSlot,
    variables: { input }
  });
  return result.data.updateAppointmentSlot;
};

// Delete a slot
export const deleteSlot = async (id) => {
  const result = await client.graphql({
    query: deleteAppointmentSlot,
    variables: { input: { id } }
  });
  return result.data.deleteAppointmentSlot;
};
